import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { numberFromStringSchema, FormInitializerReturnType } from 'src/Configuration/validation'
import { DynamicPricesSettings, DynamicPricesSettingsForm, PRICE_FALLBACK_THREE_DEC } from 'src/Libs/dynamic-power-prices/types'
import { object } from 'yup'

/**
 *  Initializes the form for editing powerPriceLimit settings
 * @param model DynamicPricesSettings
 * @returns initialValues and validationSchema for powerPriceLimits settings form
 */
export const usePowerPriceLimitSettingsFormInitializer = (
  model?: DynamicPricesSettings | null
): FormInitializerReturnType<DynamicPricesSettingsForm, DynamicPricesSettingsForm> => {
  const { t } = useCustomTranslation()
  const numberFromStringSchemaWithTranslation = numberFromStringSchema(t)
  const initialValues: DynamicPricesSettingsForm = {
    priceLimitWallbox: model?.priceLimitWallbox ?? PRICE_FALLBACK_THREE_DEC,
    priceLimitBattery: model?.priceLimitBattery ?? PRICE_FALLBACK_THREE_DEC,
  }

  const validationSchema = object().shape({
    priceLimitWallbox: numberFromStringSchemaWithTranslation().required(),
    priceLimitBattery: numberFromStringSchemaWithTranslation().required(),
  })
  return { initialValues, validationSchema }
}
